import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi, { HttpBackendOptions } from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

export const enum ELanguage {
  DE = 'de',
  EN = 'en',
  FR = 'fr',
  IT = 'it',
}

export const LANGUAGE_NAMES = {
  [ELanguage.DE]: 'Deutsch',
  [ELanguage.EN]: 'English',
  [ELanguage.FR]: 'Français',
  [ELanguage.IT]: 'Italiano',
} as const;

export const AVAILABLE_LANGUAGES = [ELanguage.DE, ELanguage.EN, ELanguage.FR, ELanguage.IT] as const;

export const DEFAULT_LANGUAGE = ELanguage.DE;

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(HttpApi)
  .init<HttpBackendOptions>({
    fallbackLng: DEFAULT_LANGUAGE,
    detection: {
      order: ['localStorage', 'cookie'],
      caches: ['localStorage', 'cookie'],
    },
    appendNamespaceToCIMode: true,
    ns: [
      'billing',
      'compare',
      'dashboard',
      'forms',
      'general',
      'integrations',
      'library',
      'modals',
      'profile',
      'project',
      'shop',
      'units',
      'user',
    ],
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    interpolation: {
      escapeValue: false,
    },
  })
  .then(() => {});

export default i18n;
